import "./AboutAmbassadors.scss";
import React from 'react';

const AboutAmbassadors = () => {
  const heroBg = "/images/ambassadors/01.jpg";
  
  // 실제 데이터가 있을 경우 여기에 추가
  const ambassadors = [
    // 예시 데이터
    {
      name: '임서린',
      major: '생명과학과',
      year: '25학번',
      position: '회장',
    },
    {
      name: '홍성윤',
      major: 'AI융합학과',
      year: '25학번',
      position: '부회장',
    },
    {
      name: '구민건',
      major: '기계로봇공학과',
      year: '25학번',
      position: '대내부장',
    },
    {
      name: '임정훈',
      major: '전기전자컴퓨터공학과',
      year: '25학번',
      position: '대외부장',
    },
    {
      name: '지예나',
      major: '전기전자컴퓨터공학과',
      year: '25학번',
      position: '미디어부장',
    },
  ];

  return (
    <div className="AboutAmbassadors">

      <section className="sec-about-hero">
        <div className="hero-overlay2" />
          <div className="AboutHero">
            <div className="box-main">
              <h1 className="about-title">홍보대사 프로필</h1>
              <p className="about-desc">
                GIST를 사랑하는 마음으로 여러분을 맞이합니다.
              </p>
            </div>
        </div>
      </section>

      <section className="sec-ambassadors">
        <div className="Ambassadors">
          <div className="box-main">
            <h2 className="ambassadors-title">2026 지온나래</h2>
            <p className="ambassadors-subtitle">
              현재 활동 중인 홍보대사를 소개합니다
            </p>

            {ambassadors.length > 0 ? (
              <div className="box-ambassadors">
                {ambassadors.map((ambassador, index) => (
                  <article key={index} className="art-ambassador">
                    <div className="box-ambassador-image">
                      <span>프로필 사진</span>
                    </div>
                    <div className="box-ambassador-info">
                      <div className="ambassador-name">{ambassador.name}</div>
                      <div className="ambassador-major">{ambassador.major}</div>
                      <div className="ambassador-year">{ambassador.year}</div>
                      <div className="ambassador-position">{ambassador.position}</div>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="box-empty">
                <div className="empty-icon">👥</div>
                <p className="empty-text">
                  홍보대사 프로필이 곧 업데이트됩니다.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutAmbassadors;
